import { DotsSixVertical } from '@phosphor-icons/react'
import * as React from 'react'

export const DragHandle = () => {
  return <DotsSixVertical className="h-4 text-gray-600 w-4" weight="bold" />
}
